jQuery(document).ready(function ($) {
    // Wait for WooCommerce content to be fully loaded
    const waitForWooCommerce = () => {
      const productImages = $('.product-img');
      
      if (productImages.length > 0) {
        initializeGallery(productImages);
      } else {
        // Retry after a short delay
        setTimeout(waitForWooCommerce, 100);
      }
    };
  
    // Initialize fullscreen gallery
    const initializeGallery = (images) => {
      const fullscreenGallery = $('#fullscreen-gallery');
      const fullscreenImage = $('#fullscreen-image');
      const closeBtn = $('.gallery-close');
      const prevBtn = $('#prev-image');
      const nextBtn = $('#next-image');
  
      let currentIndex = 0;
  
      // Open fullscreen gallery
      const openGallery = (index) => {
        currentIndex = index;
        fullscreenImage.attr('src', $(images[currentIndex]).attr('src'));
        fullscreenGallery.removeClass('hidden');
      };
  
      // Close fullscreen gallery
      const closeGallery = () => {
        fullscreenGallery.addClass('hidden');
      };
  
      // Show the previous image
      const showPrevImage = () => {
        currentIndex = (currentIndex - 1 + images.length) % images.length;
        fullscreenImage.attr('src', $(images[currentIndex]).attr('src'));
      };
  
      // Show the next image
      const showNextImage = () => {
        currentIndex = (currentIndex + 1) % images.length;
        fullscreenImage.attr('src', $(images[currentIndex]).attr('src'));
      };
  
      // Add click events to each product image
      images.each(function (index, img) {
        $(img).on('click', () => openGallery(index));
      });
  
      // Event listeners for gallery controls
      closeBtn.on('click', closeGallery);
      prevBtn.on('click', showPrevImage);
      nextBtn.on('click', showNextImage);
  
      // Close gallery on outside click
      fullscreenGallery.on('click', (e) => {
        if ($(e.target).is(fullscreenGallery)) closeGallery();
      });
    };
  
    // Start waiting for WooCommerce content
    waitForWooCommerce();
  });
  